import * as React from 'react';
import {
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  CircularProgress,
} from '@mui/material';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export default function Users({ Options, loading }) {
  const getLastLoginText = (dateString) => {
    if (!dateString) return 'Never logged in';

    const lastLogin = dayjs(dateString);
    const now = dayjs();
    const diffInMinutes = now.diff(lastLogin, 'minute');
    return diffInMinutes <= 5 ? 'Online' : lastLogin.fromNow();
  };

  function Row({ user }) {
    return (
      <>
        <TableRow>
          <TableCell component="th" scope="row">
            {user?.['user.first_name']} {user?.['user.last_name']}
          </TableCell>
          <TableCell align="right">{user?.generatedCount}</TableCell>
          <TableCell align="right">
            {getLastLoginText(user?.['user.lastLogin'])}
          </TableCell>
        </TableRow>
      </>
    );
  }

  return (
    <>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '75vh',
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer
          component={Paper}
          sx={{ minWidth: '80vw', maxHeight: '62vh', overflow: 'auto' }}
        >
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow
                sx={{ position: 'sticky', top: 0, backgroundColor: '#fff' }}
              >
                <TableCell sx={{ fontWeight: 'bold' }}>User Name</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                  Total Generated Templates
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                  Last Active
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Options?.map((user, index) => (
                <Row key={index} user={user} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
